<div class="detail-main">
   <ng-content select="[ndtLeftColumn]"></ng-content>
   <ng-content select="[ndtRightColumn]"></ng-content>
</div>
<ng-content></ng-content>
